import { render, staticRenderFns } from "./informes.vue?vue&type=template&id=9fe986dc&"
import script from "./informes.vue?vue&type=script&lang=ts&"
export * from "./informes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports